import {
  UPDATE_ASSESSMENT_TEMPLATE_LIST,
  TOGGLE_ASSESSMENT_TEMPLATE_LIST_LOADING,
  TEMPLATE_ASSESSMENT_LIST_ERROR,
  TEMPLATE_ASSESSMENT_UPDATE_TOTAL_LIST,
  TEMPLATE_ASSESSMENT_EXPORT_CHECKED_IDS
} from '../actions/dataEntryAssessmentTemplatesActions';

const initState = {
  name: 'Assessment Templates',
  settings: {
    loading: false,
    templateTypes: {},
    questionTypes: {}
  },
  templates: {
    loading: true,
    list: [],
    error: null,
    totalRecords: 0,
    checkedIds: []
  }
};

const dataEntryAssessmentTemplatesReducer = (state = initState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case UPDATE_ASSESSMENT_TEMPLATE_LIST:
      newState.templates.list = action.payload.value;
      break;
    case TOGGLE_ASSESSMENT_TEMPLATE_LIST_LOADING:
      newState.templates.loading = action.payload.value;
      break;
    case TEMPLATE_ASSESSMENT_LIST_ERROR:
      newState.templates.error = action.payload.value;
      break;
    case TEMPLATE_ASSESSMENT_UPDATE_TOTAL_LIST:
      newState.templates.totalRecords = action.payload.value;
      break;
    case TEMPLATE_ASSESSMENT_EXPORT_CHECKED_IDS:
      newState.templates.checkedIds = action.ids;
      break;
    default:
      break;
  }
  return newState;
};

export default dataEntryAssessmentTemplatesReducer;
